import { Component, OnInit } from '@angular/core'

import { AuthService } from '@core/services'
import { ActivatedRoute } from '@angular/router'
import { environment } from "@env"
import { APPLICATION_MAP } from '@core/constants/application.constants'
import { getAppName } from '@core/utils/application.utils'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    const { application } = this.route.snapshot.params
    const appName = getAppName(application)

    if (environment[appName].hasAuth) {
      this.authService.applicationName = appName
      this.authService.startSigninMainWindow()
    } else {
      window.location.href = environment[appName].REDIRECT_LOGGED_URL
    }
  }
}
